import { createFileRoute } from '@tanstack/react-router'
import DormitoryManagement from '@/features/dormitory-management'

export const Route = createFileRoute('/_authenticated/dormitory-management/')({
  component: DormitoryManagement,
})